// Mock data for Kalamata Airport Taxi website

export const siteInfo = {
  name: "KALAMATA AIRPORT",
  tagline: "TAXI",
  phone: "+30 693 242 1170",
  whatsapp: "+306932421170",
  email: "info@Kalamata-airport-taxi.com",
  address: "Kalamata Airport, Messenia, Greece"
};

export const heroStats = {
  price: 85,
  route: "Kalamata Airport to Costa Navarino",
  duration: "45",
  popularDestinations: [
    { name: "The Westin Costa Navarino", price: 85 },
    { name: "The Romanos Costa Navarino", price: 85 },
    { name: "W Costa Navarino", price: 90 }
  ]
};

export const features = [
  { title: "Fixed Prices", subtitle: "No hidden fees" },
  { title: "Flight Tracking", subtitle: "Real-time monitoring" },
  { title: "Meet & Greet", subtitle: "Personal service" },
  { title: "24/7 Available", subtitle: "Anytime, anywhere" }
];

export const pickupLocations = [
  {
    id: 1,
    name: "KALAMATA AIRPORT",
    subtitle: "Captain Vassilis Constantakopoulos (KLX)",
    type: "airport",
    priceFrom: 85,
    destinations: 4
  },
  {
    id: 2,
    name: "ATHENS AIRPORT",
    subtitle: "Eleftherios Venizelos (ATH)",
    type: "airport",
    priceFrom: 350,
    destinations: 4
  },
  {
    id: 3,
    name: "ARAXOS AIRPORT",
    subtitle: "Araxos International (GPA)",
    type: "airport",
    priceFrom: 220,
    destinations: 4
  },
  {
    id: 4,
    name: "ATHENS CITY",
    subtitle: "City Center Pickup",
    type: "city",
    priceFrom: 340,
    destinations: 4
  },
  {
    id: 5,
    name: "PIRAEUS PORT",
    subtitle: "Main Ferry Terminal",
    type: "port",
    priceFrom: 330,
    destinations: 4
  },
  {
    id: 6,
    name: "PATRAS PORT",
    subtitle: "Ferry Terminal",
    type: "port",
    priceFrom: 280,
    destinations: 4
  },
  {
    id: 7,
    name: "KYLLINI PORT",
    subtitle: "Ferry Terminal",
    type: "port",
    priceFrom: 180,
    destinations: 4
  },
  {
    id: 8,
    name: "RAFINA PORT",
    subtitle: "Ferry Terminal",
    type: "port",
    priceFrom: 360,
    destinations: 4
  },
  {
    id: 9,
    name: "LAVRIO PORT",
    subtitle: "Ferry Terminal",
    type: "port",
    priceFrom: 370,
    destinations: 4
  }
];

export const homePopularRoutes = [
  { id: 1, from: "Kalamata Airport", to: "The Westin Costa Navarino", price: 85, distance: "45 km", duration: "45 min" },
  { id: 2, from: "Kalamata Airport", to: "The Romanos Costa Navarino", price: 85, distance: "48 km", duration: "50 min" },
  { id: 3, from: "Kalamata Airport", to: "W Costa Navarino", price: 90, distance: "50 km", duration: "50 min" },
  { id: 4, from: "Kalamata Airport", to: "Mandarin Oriental Costa Navarino", price: 95, distance: "52 km", duration: "55 min" },
  { id: 5, from: "Athens Airport", to: "The Westin Costa Navarino", price: 350, distance: "280 km", duration: "3h 20min" },
  { id: 6, from: "Athens Airport", to: "The Romanos Costa Navarino", price: 350, distance: "283 km", duration: "3h 25min" },
  { id: 7, from: "The Westin Costa Navarino", to: "Kalamata Airport", price: 85, distance: "45 km", duration: "45 min" },
  { id: 8, from: "The Romanos Costa Navarino", to: "Kalamata Airport", price: 85, distance: "48 km", duration: "50 min" },
  { id: 9, from: "Athens City", to: "The Westin Costa Navarino", price: 340, distance: "270 km", duration: "3h 10min" }
];

export const aboutFeatures = [
  {
    icon: "shield-check",
    title: "Licensed & Insured",
    description: "Fully licensed transportation service with comprehensive insurance coverage for your peace of mind."
  },
  {
    icon: "car",
    title: "Modern Fleet",
    description: "Choose from standard cars, executive vehicles, vans, and minibuses. All vehicles are well-maintained and air-conditioned."
  },
  {
    icon: "star",
    title: "Professional Drivers",
    description: "English-speaking, experienced drivers who know the region well and provide excellent service."
  },
  {
    icon: "euro",
    title: "Fixed Pricing",
    description: "Transparent pricing with no hidden fees. The price you see is the price you pay."
  }
];

export const mainRoute = {
  from: "Kalamata Airport",
  to: "Costa Navarino",
  distance: "45 km",
  duration: "45min",
  priceFrom: 85,
  service: "24/7",
  description: "Private transfer from Kalamata Airport to Costa Navarino resort.",
  fullDescription: `Our experienced drivers will meet you at Kalamata Airport and ensure a comfortable journey to Costa Navarino.
We monitor flight times and adjust pickup accordingly, so you never have to worry about delays.`
};

export const vehicles = [
  {
    id: 1,
    type: "Standard Car",
    subtitle: "Skoda Octavia or similar",
    icon: "car",
    passengers: 3,
    luggage: 3,
    hasAC: true,
    price: 85,
    description: "Comfortable sedan for up to 3 passengers",
    image: "https://images.pexels.com/photos/30809411/pexels-photo-30809411.jpeg?auto=compress&cs=tinysrgb&w=400"
  },
  {
    id: 2,
    type: "Executive Car",
    subtitle: "Mercedes E-Class or similar",
    icon: "car-front",
    passengers: 3,
    luggage: 3,
    hasAC: true,
    price: 120,
    description: "Premium sedan with extra comfort",
    image: "https://images.unsplash.com/photo-1653673337360-59a1afa7d67a?auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 3,
    type: "Standard Van",
    subtitle: "Mercedes Vito or similar",
    icon: "truck",
    passengers: 7,
    luggage: 7,
    hasAC: true,
    price: 140,
    description: "Spacious van for families",
    image: "https://images.pexels.com/photos/19871522/pexels-photo-19871522.jpeg?auto=compress&cs=tinysrgb&w=400"
  },
  {
    id: 4,
    type: "Executive Van",
    subtitle: "Mercedes V-Class or similar",
    icon: "truck",
    passengers: 7,
    luggage: 7,
    hasAC: true,
    price: 175,
    description: "Premium van with luxury amenities",
    image: "https://images.unsplash.com/photo-1549925862-990ac5b34e35?auto=format&fit=crop&w=400&q=80"
  }
];

export const includedFeatures = [
  "Door-to-door service",
  "Professional driver",
  "Flight monitoring",
  "Meet & greet service",
  "Air-conditioned vehicle",
  "Free cancellation (24h)"
];

export const otherRoutes = [
  {
    id: 1,
    from: "The Westin Costa Navarino",
    to: "Athens Airport",
    price: 350,
    distance: "280km"
  },
  {
    id: 2,
    from: "The Romanos Costa Navarino",
    to: "Kalamata Airport",
    price: 85,
    distance: "48km"
  },
  {
    id: 3,
    from: "W Costa Navarino",
    to: "Patras Port",
    price: 290,
    distance: "205km"
  }
];

export const popularRoutes = [
  {
    id: 1,
    from: "Kalamata Airport",
    to: "The Westin Costa Navarino",
    price: 85
  },
  {
    id: 2,
    from: "Kalamata Airport",
    to: "The Romanos Costa Navarino",
    price: 85
  },
  {
    id: 3,
    from: "Kalamata Airport",
    to: "W Costa Navarino",
    price: 90
  },
  {
    id: 4,
    from: "Kalamata Airport",
    to: "Mandarin Oriental Costa Navarino",
    price: 95
  },
  {
    id: 5,
    from: "Athens Airport",
    to: "The Westin Costa Navarino",
    price: 350
  },
  {
    id: 6,
    from: "Athens Airport",
    to: "The Romanos Costa Navarino",
    price: 350
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Schmidt",
    country: "Germany",
    type: "Airport Transfer",
    rating: 5,
    text: "Professional and punctual. Our flight was delayed by 2 hours but the driver tracked it and was there waiting when we arrived. Great communication throughout. Will definitely use again."
  },
  {
    id: 2,
    name: "David Thompson",
    country: "Ireland",
    type: "Round Trip Transfer",
    rating: 5,
    text: "Outstanding service! Booked a round trip and everything was perfect. Clean cars, professional drivers, and great prices. This is how transfers should be done."
  },
  {
    id: 3,
    name: "Sarah Johnson",
    country: "United Kingdom",
    type: "Airport Transfer",
    rating: 5,
    text: "Excellent service from start to finish. Our driver was waiting at Kalamata Airport with a name board and helped us with luggage. The car was spotless and comfortable. Highly recommend for transfers to Costa Navarino!"
  },
  {
    id: 4,
    name: "Anna Kowalski",
    country: "Poland",
    type: "Airport Transfer",
    rating: 5,
    text: "Reliable, professional, and friendly. The driver helped us with our luggage and made sure we were comfortable. Great experience from airport to The Westin Costa Navarino."
  },
  {
    id: 5,
    name: "James Anderson",
    country: "USA",
    type: "Airport Transfer",
    rating: 5,
    text: "Best transfer service in Messenia. Fixed prices with no surprises, comfortable vehicle, and friendly driver who gave us great tips about Costa Navarino. Five stars!"
  },
  {
    id: 6,
    name: "Emma Williams",
    country: "Australia",
    type: "Port Transfer",
    rating: 5,
    text: "Booked a transfer from Patras Port to The Romanos Costa Navarino. The driver was on time despite the ferry arriving late. Comfortable journey and very professional service. Highly recommended!"
  }
];

export const navLinks = [
  { id: 1, label: "HOME", href: "/" },
  { id: 2, label: "ROUTES", href: "/routes" },
  { id: 3, label: "CONTACT", href: "/#contact" }
];

export const destinations = [];

// Comprehensive routes data organized by pickup location
export const allRoutes = {
  // =====================
  // PICKUP POINTS TO HOTELS
  // =====================
  
  // KALAMATA AIRPORT
  "kalamata-airport": {
    name: "KALAMATA AIRPORT",
    subtitle: "All routes from Kalamata Airport (KLX)",
    routes: [
      { id: "klx-westin", from: "Kalamata Airport", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "45 km", duration: "45min", price: 85 },
      { id: "klx-romanos", from: "Kalamata Airport", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "48 km", duration: "50min", price: 85 },
      { id: "klx-w-hotel", from: "Kalamata Airport", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "50 km", duration: "50min", price: 90 },
      { id: "klx-mandarin", from: "Kalamata Airport", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "52 km", duration: "55min", price: 95 }
    ]
  },
  
  // ATHENS AIRPORT
  "athens-airport": {
    name: "ATHENS AIRPORT",
    subtitle: "All routes from Athens Airport (ATH)",
    routes: [
      { id: "ath-westin", from: "Athens Airport", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "280 km", duration: "3h 20min", price: 350 },
      { id: "ath-romanos", from: "Athens Airport", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "283 km", duration: "3h 25min", price: 350 },
      { id: "ath-w-hotel", from: "Athens Airport", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "285 km", duration: "3h 30min", price: 360 },
      { id: "ath-mandarin", from: "Athens Airport", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "287 km", duration: "3h 35min", price: 365 }
    ]
  },
  
  // ARAXOS AIRPORT
  "araxos-airport": {
    name: "ARAXOS AIRPORT",
    subtitle: "All routes from Araxos Airport (GPA)",
    routes: [
      { id: "arx-westin", from: "Araxos Airport", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "180 km", duration: "2h 20min", price: 220 },
      { id: "arx-romanos", from: "Araxos Airport", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "183 km", duration: "2h 25min", price: 220 },
      { id: "arx-w-hotel", from: "Araxos Airport", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "185 km", duration: "2h 30min", price: 230 },
      { id: "arx-mandarin", from: "Araxos Airport", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "187 km", duration: "2h 35min", price: 235 }
    ]
  },
  
  // ATHENS CITY
  "athens-city": {
    name: "ATHENS CITY",
    subtitle: "All routes from Athens City Center",
    routes: [
      { id: "athc-westin", from: "Athens City", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "270 km", duration: "3h 10min", price: 340 },
      { id: "athc-romanos", from: "Athens City", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "273 km", duration: "3h 15min", price: 340 },
      { id: "athc-w-hotel", from: "Athens City", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "275 km", duration: "3h 20min", price: 350 },
      { id: "athc-mandarin", from: "Athens City", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "277 km", duration: "3h 25min", price: 355 }
    ]
  },
  
  // PIRAEUS PORT
  "piraeus-port": {
    name: "PIRAEUS PORT",
    subtitle: "All routes from Piraeus Port",
    routes: [
      { id: "pir-westin", from: "Piraeus Port", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "265 km", duration: "3h 5min", price: 330 },
      { id: "pir-romanos", from: "Piraeus Port", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "268 km", duration: "3h 10min", price: 330 },
      { id: "pir-w-hotel", from: "Piraeus Port", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "270 km", duration: "3h 15min", price: 340 },
      { id: "pir-mandarin", from: "Piraeus Port", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "272 km", duration: "3h 20min", price: 345 }
    ]
  },
  
  // PATRAS PORT
  "patras-port": {
    name: "PATRAS PORT",
    subtitle: "All routes from Patras Port",
    routes: [
      { id: "ptp-westin", from: "Patras Port", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "200 km", duration: "2h 30min", price: 280 },
      { id: "ptp-romanos", from: "Patras Port", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "203 km", duration: "2h 35min", price: 280 },
      { id: "ptp-w-hotel", from: "Patras Port", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "205 km", duration: "2h 40min", price: 290 },
      { id: "ptp-mandarin", from: "Patras Port", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "207 km", duration: "2h 45min", price: 295 }
    ]
  },
  
  // KYLLINI PORT
  "kyllini-port": {
    name: "KYLLINI PORT",
    subtitle: "All routes from Kyllini Port",
    routes: [
      { id: "kyl-westin", from: "Kyllini Port", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "150 km", duration: "2h", price: 180 },
      { id: "kyl-romanos", from: "Kyllini Port", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "153 km", duration: "2h 5min", price: 180 },
      { id: "kyl-w-hotel", from: "Kyllini Port", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "155 km", duration: "2h 10min", price: 190 },
      { id: "kyl-mandarin", from: "Kyllini Port", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "157 km", duration: "2h 15min", price: 195 }
    ]
  },
  
  // RAFINA PORT
  "rafina-port": {
    name: "RAFINA PORT",
    subtitle: "All routes from Rafina Port",
    routes: [
      { id: "raf-westin", from: "Rafina Port", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "295 km", duration: "3h 30min", price: 360 },
      { id: "raf-romanos", from: "Rafina Port", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "298 km", duration: "3h 35min", price: 360 },
      { id: "raf-w-hotel", from: "Rafina Port", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "300 km", duration: "3h 40min", price: 370 },
      { id: "raf-mandarin", from: "Rafina Port", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "302 km", duration: "3h 45min", price: 375 }
    ]
  },
  
  // LAVRIO PORT
  "lavrio-port": {
    name: "LAVRIO PORT",
    subtitle: "All routes from Lavrio Port",
    routes: [
      { id: "lav-westin", from: "Lavrio Port", to: "The Westin Costa Navarino", slug: "the-westin-costa-navarino", distance: "305 km", duration: "3h 40min", price: 370 },
      { id: "lav-romanos", from: "Lavrio Port", to: "The Romanos Costa Navarino", slug: "the-romanos-costa-navarino", distance: "308 km", duration: "3h 45min", price: 370 },
      { id: "lav-w-hotel", from: "Lavrio Port", to: "W Costa Navarino", slug: "w-costa-navarino", distance: "310 km", duration: "3h 50min", price: 380 },
      { id: "lav-mandarin", from: "Lavrio Port", to: "Mandarin Oriental Costa Navarino", slug: "mandarin-oriental-costa-navarino", distance: "312 km", duration: "3h 55min", price: 385 }
    ]
  },
  
  // =====================
  // HOTELS TO PICKUP POINTS (RETURN ROUTES)
  // =====================
  
  // THE WESTIN COSTA NAVARINO
  "the-westin-costa-navarino": {
    name: "THE WESTIN COSTA NAVARINO",
    subtitle: "All routes from The Westin Costa Navarino",
    routes: [
      { id: "wst-klx", from: "The Westin Costa Navarino", to: "Kalamata Airport", slug: "kalamata-airport", distance: "45 km", duration: "45min", price: 85 },
      { id: "wst-ath", from: "The Westin Costa Navarino", to: "Athens Airport", slug: "athens-airport", distance: "280 km", duration: "3h 20min", price: 350 },
      { id: "wst-arx", from: "The Westin Costa Navarino", to: "Araxos Airport", slug: "araxos-airport", distance: "180 km", duration: "2h 20min", price: 220 },
      { id: "wst-athc", from: "The Westin Costa Navarino", to: "Athens City", slug: "athens-city", distance: "270 km", duration: "3h 10min", price: 340 },
      { id: "wst-pir", from: "The Westin Costa Navarino", to: "Piraeus Port", slug: "piraeus-port", distance: "265 km", duration: "3h 5min", price: 330 },
      { id: "wst-ptp", from: "The Westin Costa Navarino", to: "Patras Port", slug: "patras-port", distance: "200 km", duration: "2h 30min", price: 280 },
      { id: "wst-kyl", from: "The Westin Costa Navarino", to: "Kyllini Port", slug: "kyllini-port", distance: "150 km", duration: "2h", price: 180 },
      { id: "wst-raf", from: "The Westin Costa Navarino", to: "Rafina Port", slug: "rafina-port", distance: "295 km", duration: "3h 30min", price: 360 },
      { id: "wst-lav", from: "The Westin Costa Navarino", to: "Lavrio Port", slug: "lavrio-port", distance: "305 km", duration: "3h 40min", price: 370 }
    ]
  },
  
  // THE ROMANOS COSTA NAVARINO
  "the-romanos-costa-navarino": {
    name: "THE ROMANOS COSTA NAVARINO",
    subtitle: "All routes from The Romanos Costa Navarino",
    routes: [
      { id: "rom-klx", from: "The Romanos Costa Navarino", to: "Kalamata Airport", slug: "kalamata-airport", distance: "48 km", duration: "50min", price: 85 },
      { id: "rom-ath", from: "The Romanos Costa Navarino", to: "Athens Airport", slug: "athens-airport", distance: "283 km", duration: "3h 25min", price: 350 },
      { id: "rom-arx", from: "The Romanos Costa Navarino", to: "Araxos Airport", slug: "araxos-airport", distance: "183 km", duration: "2h 25min", price: 220 },
      { id: "rom-athc", from: "The Romanos Costa Navarino", to: "Athens City", slug: "athens-city", distance: "273 km", duration: "3h 15min", price: 340 },
      { id: "rom-pir", from: "The Romanos Costa Navarino", to: "Piraeus Port", slug: "piraeus-port", distance: "268 km", duration: "3h 10min", price: 330 },
      { id: "rom-ptp", from: "The Romanos Costa Navarino", to: "Patras Port", slug: "patras-port", distance: "203 km", duration: "2h 35min", price: 280 },
      { id: "rom-kyl", from: "The Romanos Costa Navarino", to: "Kyllini Port", slug: "kyllini-port", distance: "153 km", duration: "2h 5min", price: 180 },
      { id: "rom-raf", from: "The Romanos Costa Navarino", to: "Rafina Port", slug: "rafina-port", distance: "298 km", duration: "3h 35min", price: 360 },
      { id: "rom-lav", from: "The Romanos Costa Navarino", to: "Lavrio Port", slug: "lavrio-port", distance: "308 km", duration: "3h 45min", price: 370 }
    ]
  },
  
  // W COSTA NAVARINO
  "w-costa-navarino": {
    name: "W COSTA NAVARINO",
    subtitle: "All routes from W Costa Navarino",
    routes: [
      { id: "wcn-klx", from: "W Costa Navarino", to: "Kalamata Airport", slug: "kalamata-airport", distance: "50 km", duration: "50min", price: 90 },
      { id: "wcn-ath", from: "W Costa Navarino", to: "Athens Airport", slug: "athens-airport", distance: "285 km", duration: "3h 30min", price: 360 },
      { id: "wcn-arx", from: "W Costa Navarino", to: "Araxos Airport", slug: "araxos-airport", distance: "185 km", duration: "2h 30min", price: 230 },
      { id: "wcn-athc", from: "W Costa Navarino", to: "Athens City", slug: "athens-city", distance: "275 km", duration: "3h 20min", price: 350 },
      { id: "wcn-pir", from: "W Costa Navarino", to: "Piraeus Port", slug: "piraeus-port", distance: "270 km", duration: "3h 15min", price: 340 },
      { id: "wcn-ptp", from: "W Costa Navarino", to: "Patras Port", slug: "patras-port", distance: "205 km", duration: "2h 40min", price: 290 },
      { id: "wcn-kyl", from: "W Costa Navarino", to: "Kyllini Port", slug: "kyllini-port", distance: "155 km", duration: "2h 10min", price: 190 },
      { id: "wcn-raf", from: "W Costa Navarino", to: "Rafina Port", slug: "rafina-port", distance: "300 km", duration: "3h 40min", price: 370 },
      { id: "wcn-lav", from: "W Costa Navarino", to: "Lavrio Port", slug: "lavrio-port", distance: "310 km", duration: "3h 50min", price: 380 }
    ]
  },
  
  // MANDARIN ORIENTAL COSTA NAVARINO
  "mandarin-oriental-costa-navarino": {
    name: "MANDARIN ORIENTAL COSTA NAVARINO",
    subtitle: "All routes from Mandarin Oriental Costa Navarino",
    routes: [
      { id: "mnd-klx", from: "Mandarin Oriental Costa Navarino", to: "Kalamata Airport", slug: "kalamata-airport", distance: "52 km", duration: "55min", price: 95 },
      { id: "mnd-ath", from: "Mandarin Oriental Costa Navarino", to: "Athens Airport", slug: "athens-airport", distance: "287 km", duration: "3h 35min", price: 365 },
      { id: "mnd-arx", from: "Mandarin Oriental Costa Navarino", to: "Araxos Airport", slug: "araxos-airport", distance: "187 km", duration: "2h 35min", price: 235 },
      { id: "mnd-athc", from: "Mandarin Oriental Costa Navarino", to: "Athens City", slug: "athens-city", distance: "277 km", duration: "3h 25min", price: 355 },
      { id: "mnd-pir", from: "Mandarin Oriental Costa Navarino", to: "Piraeus Port", slug: "piraeus-port", distance: "272 km", duration: "3h 20min", price: 345 },
      { id: "mnd-ptp", from: "Mandarin Oriental Costa Navarino", to: "Patras Port", slug: "patras-port", distance: "207 km", duration: "2h 45min", price: 295 },
      { id: "mnd-kyl", from: "Mandarin Oriental Costa Navarino", to: "Kyllini Port", slug: "kyllini-port", distance: "157 km", duration: "2h 15min", price: 195 },
      { id: "mnd-raf", from: "Mandarin Oriental Costa Navarino", to: "Rafina Port", slug: "rafina-port", distance: "302 km", duration: "3h 45min", price: 375 },
      { id: "mnd-lav", from: "Mandarin Oriental Costa Navarino", to: "Lavrio Port", slug: "lavrio-port", distance: "312 km", duration: "3h 55min", price: 385 }
    ]
  }
};

// Helper function to get route by slug
export const getRouteBySlug = (fromSlug, toSlug) => {
  const locationData = allRoutes[fromSlug];
  if (!locationData) return null;
  return locationData.routes.find(r => r.slug === toSlug);
};

